"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.requestOption = exports.fetch = void 0;
const axios_1 = __importDefault(require("axios"));
const constants_1 = require("./constants");
exports.fetch = axios_1.default.create({
    baseURL: `${constants_1.CONFIG.protocol}://${constants_1.CONFIG.host}/${constants_1.CONFIG.version}`,
});
// @ts-expect-error ts-migrate(7006) FIXME: Parameter 'req' implicitly has an 'any' type.
const requestOption = (req, token) => ({
    ...req,
    headers: {
        ...req.headers,
        Authorization: `Bearer ${token}`,
    }
});
exports.requestOption = requestOption;
//# sourceMappingURL=index.js.map